export default __webpack_public_path__ + "static/media/send_estimate.83898a1c.svg";